/**
 * Cart recommendation cards: colour swatches + dropdowns.
 *
 * Works with snippets/cart-recommendation-card.liquid. This script does NOT
 * add anything to the cart. The theme's own product-card-basic form does that
 * (including the drawer refresh and cart count). This script only keeps the
 * form's hidden variant id, the price, the image and the button state in line
 * with what the customer has chosen.
 *
 * Everything is attached to the document, so cards that are loaded later
 * (recommendations fetched by the theme, drawer re-rendered after a cart
 * change) work without extra setup.
 */
(function () {
  'use strict';

  if (window.__cartRecommendationCards) return;
  window.__cartRecommendationCards = true;

  var CARD = '[data-rec-card]';

  function getVariants(card) {
    if (!card.__recVariants) {
      var el = card.querySelector('[data-rec-variants]');
      try {
        card.__recVariants = JSON.parse(el ? el.textContent : '[]');
      } catch (e) {
        card.__recVariants = [];
      }
    }
    return card.__recVariants;
  }

  function controlValue(control) {
    if (control.tagName === 'SELECT') return control.value;
    var active = control.querySelector('[data-rec-swatch][aria-pressed="true"]');
    return active ? active.getAttribute('data-value') : '';
  }

  // Current choice for every option, in option order
  function selectedValues(card) {
    var values = [];
    card.querySelectorAll('[data-rec-option]').forEach(function (control) {
      values[Number(control.getAttribute('data-rec-option'))] = controlValue(control);
    });
    return values;
  }

  function applyValues(card, optionValues) {
    card.querySelectorAll('[data-rec-option]').forEach(function (control) {
      var value = optionValues[Number(control.getAttribute('data-rec-option'))];
      if (control.tagName === 'SELECT') {
        control.value = value;
      } else {
        control.querySelectorAll('[data-rec-swatch]').forEach(function (swatch) {
          var on = swatch.getAttribute('data-value') === value;
          swatch.setAttribute('aria-pressed', on ? 'true' : 'false');
          swatch.classList.toggle('is-active', on);
        });
      }
    });
  }

  function matchVariant(variants, values) {
    for (var i = 0; i < variants.length; i++) {
      var variant = variants[i];
      var matches = true;
      for (var k = 0; k < values.length; k++) {
        if (variant.o[k] !== values[k]) {
          matches = false;
          break;
        }
      }
      if (matches) return variant;
    }
    return null;
  }

  function cardImage(card) {
    return card.querySelector('.product-card-basic__image img');
  }

  // Show a different photo (url), or put the original back (no url).
  // The theme's <img> uses srcset, which would override a changed src, so it is removed while swapped.
  function showImage(card, url) {
    var img = cardImage(card);
    if (!img) return;
    if (img.getAttribute('data-rec-orig-src') === null) {
      img.setAttribute('data-rec-orig-src', img.getAttribute('src') || '');
      img.setAttribute('data-rec-orig-srcset', img.getAttribute('srcset') || '');
      img.setAttribute('data-rec-orig-sizes', img.getAttribute('sizes') || '');
    }
    if (url) {
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      if (img.getAttribute('src') !== url) img.setAttribute('src', url);
    } else {
      img.setAttribute('src', img.getAttribute('data-rec-orig-src'));
      var srcset = img.getAttribute('data-rec-orig-srcset');
      var sizes = img.getAttribute('data-rec-orig-sizes');
      if (srcset) img.setAttribute('srcset', srcset);
      if (sizes) img.setAttribute('sizes', sizes);
    }
  }

  // Photo for the current choice (null = the product's main photo)
  function selectedImage(card) {
    var variant = matchVariant(getVariants(card), selectedValues(card));
    return variant && variant.i ? variant.i : null;
  }

  // Only products whose price changes by variant get a live price,
  // so every other card keeps the theme's own price markup untouched.
  function renderPrice(card, variant) {
    if (card.getAttribute('data-price-varies') !== 'true' || !variant) return;
    var el = card.querySelector('.product-card-basic__price');
    if (!el) return;
    el.textContent = '';
    if (variant.c) {
      var compare = document.createElement('s');
      compare.textContent = variant.c;
      compare.style.marginRight = '6px';
      el.appendChild(compare);
    }
    var current = document.createElement('span');
    current.textContent = variant.p;
    el.appendChild(current);
  }

  // Sync a card to its current choice
  function update(card) {
    var variants = getVariants(card);
    if (!variants.length) return;

    var values = selectedValues(card);
    var variant = matchVariant(variants, values);
    var soldOutText = card.getAttribute('data-label-sold-out') || 'Sold out';
    var unavailableText = card.getAttribute('data-label-unavailable') || 'Unavailable';

    card.querySelectorAll('[data-rec-option]').forEach(function (control) {
      var index = Number(control.getAttribute('data-rec-option'));

      if (control.tagName === 'SELECT') {
        // Mark values that can't be bought with the other current choices
        Array.prototype.forEach.call(control.options, function (option) {
          var test = values.slice();
          test[index] = option.value;
          var match = matchVariant(variants, test);
          option.disabled = !match || !match.a;
          option.textContent = !match
            ? option.value + ' - ' + unavailableText
            : (!match.a ? option.value + ' - ' + soldOutText : option.value);
        });
      } else {
        // A colour is only disabled if none of its variants are in stock
        control.querySelectorAll('[data-rec-swatch]').forEach(function (swatch) {
          var colour = swatch.getAttribute('data-value');
          var inStock = variants.some(function (v) { return v.a && v.o[index] === colour; });
          swatch.disabled = !inStock;
          swatch.classList.toggle('is-sold-out', !inStock);
        });
      }
    });

    var input = card.querySelector('[data-rec-variant-input]');
    if (input && variant) input.value = String(variant.id);

    renderPrice(card, variant);
    showImage(card, variant && variant.i ? variant.i : null);

    var button = card.querySelector('[data-rec-add]');
    var label = card.querySelector('[data-rec-add-label]');
    if (button && label) {
      var canBuy = !!(variant && variant.a);
      button.disabled = !canBuy;
      label.textContent = canBuy
        ? card.getAttribute('data-label-add')
        : (variant ? soldOutText : unavailableText);
    }
  }

  function initCards(root) {
    (root || document).querySelectorAll(CARD + ':not([data-rec-ready])').forEach(function (card) {
      card.setAttribute('data-rec-ready', '');
      update(card);
    });
  }

  // Dropdown changed
  document.addEventListener('change', function (event) {
    var select = event.target.closest && event.target.closest('select[data-rec-option]');
    if (!select) return;
    var card = select.closest(CARD);
    if (card) update(card);
  });

  // Colour swatch clicked
  document.addEventListener('click', function (event) {
    var swatch = event.target.closest && event.target.closest('[data-rec-swatch]');
    if (!swatch || swatch.disabled) return;
    var card = swatch.closest(CARD);
    var group = swatch.closest('[data-rec-option]');
    if (!card || !group) return;

    var index = Number(group.getAttribute('data-rec-option'));
    var colour = swatch.getAttribute('data-value');
    var variants = getVariants(card);

    var values = selectedValues(card);
    values[index] = colour;

    // If the current size isn't available in this colour, move to the
    // first available variant of that colour so they never hit a dead end.
    var match = matchVariant(variants, values);
    if (!match || !match.a) {
      var fallback = variants.filter(function (v) { return v.a && v.o[index] === colour; })[0];
      if (fallback) values = fallback.o.slice();
    }

    applyValues(card, values);
    update(card);
  });

  // Hovering a swatch previews that colour's photo; leaving puts back the chosen one
  document.addEventListener('mouseover', function (event) {
    var swatch = event.target.closest && event.target.closest('[data-rec-swatch]');
    if (!swatch) return;
    var card = swatch.closest(CARD);
    var url = swatch.getAttribute('data-image');
    if (card && url) showImage(card, url);
  });

  document.addEventListener('mouseout', function (event) {
    var swatch = event.target.closest && event.target.closest('[data-rec-swatch]');
    if (!swatch) return;
    if (event.relatedTarget && swatch.contains(event.relatedTarget)) return;
    var card = swatch.closest(CARD);
    if (card) showImage(card, selectedImage(card));
  });

  // Pinned products become the FIRST items of the theme's recommendations
  // list (the sideways carousel on mobile). They are copied in, so if the theme
  // re-renders its list they are simply put back. If the theme's list isn't
  // there (no automatic recommendations), the separate pinned group stays visible.
  //
  // The result is written on the pinned group as data-merge-status
  // ("merged" / "waiting-for-list" / ...) so it can be checked in DevTools.

  function describe(el) {
    if (!el) return 'nothing';
    var cls = typeof el.className === 'string' && el.className.trim()
      ? '.' + el.className.trim().split(/\s+/).join('.')
      : '';
    return el.tagName.toLowerCase() + cls;
  }

  // The element that holds the automatic recommendation cards.
  // Normally the theme's .cart-drawer__recommendations-grid. If the theme uses
  // different markup, start at the first card and climb out of any wrapper that
  // contains only that card (e.g. a slide) to reach the list of all the cards.
  function findList(recs) {
    var list = recs.querySelector('.cart-drawer__recommendations-grid');
    if (list) return list;
    var node = recs.querySelector('.product-card-basic');
    if (!node) return null;
    while (node.parentElement && node.parentElement !== recs && node.parentElement.children.length === 1) {
      node = node.parentElement;
    }
    return node.parentElement;
  }

  function cardOf(el) {
    return el.matches && el.matches('[data-rec-card]') ? el : el.querySelector('[data-rec-card]');
  }

  function syncPinned() {
    document.querySelectorAll('[data-cart-pinned-recommendations]').forEach(function (container) {
      var panel = container.parentElement;
      var recs = panel && panel.querySelector('cart-recommendations');
      var list = recs && findList(recs);
      var originals = container.querySelectorAll('[data-rec-card]');

      if (!originals.length) {
        container.setAttribute('data-merge-status', 'no-pinned-cards');
        return;
      }

      if (!list) {
        container.hidden = false;
        container.style.display = '';
        container.setAttribute('data-merge-status', recs ? 'waiting-for-list' : 'no-recommendations-element');
        container.setAttribute('data-merge-debug', recs ? 'inside cart-recommendations: ' + describe(recs.firstElementChild) : '');
        return;
      }

      var children = Array.prototype.slice.call(list.children);
      var sample = children.filter(function (el) { return !el.hasAttribute('data-rec-pinned-clone'); })[0];
      // Some carousels wrap every card in its own slide element; copy that wrapper too
      var wrapped = !!sample && !sample.matches('.product-card-basic');
      var merged = children.filter(function (el) { return el.hasAttribute('data-rec-pinned-clone'); });
      var inOrder = merged.length === originals.length && merged.every(function (el, i) {
        var card = cardOf(el);
        return children[i] === el && card && card.getAttribute('data-product-id') === originals[i].getAttribute('data-product-id');
      });

      if (!inOrder) {
        merged.forEach(function (el) { el.remove(); });
        var fragment = document.createDocumentFragment();
        Array.prototype.forEach.call(originals, function (card) {
          var copy = card.cloneNode(true);
          copy.removeAttribute('data-rec-ready');
          var item = copy;
          if (wrapped) {
            item = sample.cloneNode(false);
            item.appendChild(copy);
          }
          item.setAttribute('data-rec-pinned-clone', '');
          fragment.appendChild(item);
        });
        list.insertBefore(fragment, list.firstChild);
      }

      container.hidden = true;
      container.style.display = 'none';
      container.setAttribute('data-merge-status', 'merged');
      container.setAttribute('data-merge-debug', 'list: ' + describe(list) + (wrapped ? ' (cards wrapped in ' + describe(sample) + ')' : ''));
    });
  }

  // Set up the cards on the page and any added later
  initCards(document);
  syncPinned();

  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      syncPinned();
      initCards(document);
    });
  }).observe(document.querySelector('cart-drawer') || document.body, { childList: true, subtree: true });
})();